import {
  GET_CUSTOMERS,
  GET_CUSTOMERS_SUCCESS,
  GET_CUSTOMERS_ERROR,
  ADD_CUSTOMER,
  ADD_CUSTOMER_SUCCESS,
  ADD_CUSTOMER_ERROR,
  GET_CUSTOMER,
  GET_CUSTOMER_SUCCESS,
  GET_CUSTOMER_ERROR,
  UPDATE_CUSTOMER,
  UPDATE_CUSTOMER_SUCCESS,
  UPDATE_CUSTOMER_ERROR,
  DELETE_CUSTOMER,
  DELETE_CUSTOMER_SUCCESS,
  DELETE_CUSTOMER_ERROR,
  TOGGLE_CUSTOMER_MODAL,
  TOGGLE_CUSTOMER_BLOCK_MODAL,
} from "./actionTypes";

export const getCustomers = (request) => {
  return {
    type: GET_CUSTOMERS,
    payload: { request },
  };
};

export const getCustomersSuccess = (paginatedCustomers) => {
  return {
    type: GET_CUSTOMERS_SUCCESS,
    payload: paginatedCustomers,
  };
};

export const getCustomersError = (message) => {
  return {
    type: GET_CUSTOMERS_ERROR,
    payload: message,
  };
};

export const toggleCustomerModalAction = () => {
  return {
    type: TOGGLE_CUSTOMER_MODAL,
  };
};

export const addCustomer = (request) => {
  return {
    type: ADD_CUSTOMER,
    payload: { request },
  };
};

export const addCustomerSuccess = () => {
  return {
    type: ADD_CUSTOMER_SUCCESS,
  };
};

export const addCustomerError = (error) => {
  return {
    type: ADD_CUSTOMER_ERROR,
    payload: error,
  };
};

export const getCustomer = (id) => {
  return {
    type: GET_CUSTOMER,
    payload: { id },
  };
};

export const getCustomerSuccess = (customer) => {
  return {
    type: GET_CUSTOMER_SUCCESS,
    payload: customer,
  };
};

export const getCustomerError = (message) => {
  return {
    type: GET_CUSTOMER_ERROR,
    payload: message,
  };
};

export const updateCustomer = (request) => {
  return {
    type: UPDATE_CUSTOMER,
    payload: { request },
  };
};

export const updateCustomerSuccess = () => {
  return {
    type: UPDATE_CUSTOMER_SUCCESS,
  };
};

export const updateCustomerError = (error) => {
  return {
    type: UPDATE_CUSTOMER_ERROR,
    payload: error,
  };
};

export const deleteCustomer = (id) => {
  return {
    type: DELETE_CUSTOMER,
    payload: { id },
  };
};

export const deleteCustomerSuccess = () => {
  return {
    type: DELETE_CUSTOMER_SUCCESS,
  };
};

export const deleteCustomerError = (error) => {
  return {
    type: DELETE_CUSTOMER_ERROR,
    payload: error,
  };
};

export const toggleCustomerBlockModalAction = () => {
  return {
    type: TOGGLE_CUSTOMER_BLOCK_MODAL,
  };
};
